module.exports = __webpack_public_path__ + "static/img/Kiitoskortti_Avecor_tuukka-smura_A4.b985f52.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/salesperson-leaflets/Kiitoskortti_Avecor_tuukka-smura_A4.pdf
// module id = a2mY
// module chunks = 22